/* global axios */
import ApiClient from './ApiClient';

class AccountChatSettingApi extends ApiClient {
  constructor() {
    super('account_chat_setting', { accountScoped: true });
  }

  get() {
    return axios.get(`${this.url}`);
  }

  update(data) {
    return axios.put(`${this.url}`, data);
  }
}

export default new AccountChatSettingApi();
